import React from 'react';
import { NavLink } from 'react-router-dom';

// Small underline-style tab strip. `tabs` is `[{ to, label }]`. Uses NavLink
// so react-router marks the active tab based on the current URL.
export default function TabStrip({ tabs }) {
  return (
    <nav
      style={{
        display: 'flex',
        gap: 'var(--space-2)',
        borderBottom: '1px solid var(--border-subtle)',
        marginBottom: 'var(--space-5)',
      }}
      aria-label="Section tabs"
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end !== false}
          style={({ isActive }) => ({
            padding: 'var(--space-3) var(--space-4)',
            fontSize: 'var(--text-body-size)',
            fontWeight: 600,
            color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            borderBottom: isActive
              ? '2px solid var(--accent-primary)'
              : '2px solid transparent',
            marginBottom: -1,
            transition: 'color 0.15s ease, border-color 0.15s ease',
          })}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
